import isString from 'lodash.isstring';
export default {
  version: '1.2.9',
  getIssuePage: function getIssuePage(pages, index) {
    return index === null ? null : pages[index] ? pages[index] : index >= pages.length - 1 ? pages[0] : index < 0 ? pages[pages.length - 1] : null;
  },
  getPageIndex: function getPageIndex(pages, pageId) {
    var zeroBased = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var index = null;
    pages.forEach(function (page, i) {
      index = isString(page) ? page === pageId : page['@id'] === pageId ? i : index;
    });
    return index !== null ? zeroBased ? index : index + 1 : null;
  }
};